import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  // {
  //     key: 'register',
  //     path: `${AUTH_PREFIX_PATH}/register`,
  //     component: React.lazy(() => import('views/auth-views/authentication/register')),
  // },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "apps",
    path: `${APP_PREFIX_PATH}/apps`,
    component: React.lazy(() => import("views/app-views/apps")),
  },
  {
    key: "apps.employee",
    path: `${APP_PREFIX_PATH}/apps/employee`,
    component: React.lazy(() => import("views/app-views/apps/employee")),
  },
  {
    key: "apps.employee.list",
    path: `${APP_PREFIX_PATH}/apps/employee/list`,
    component: React.lazy(() => import("views/app-views/apps/employee/list")),
  },
  {
    key: "apps.employee.create",
    path: `${APP_PREFIX_PATH}/apps/employee/create`,
    component: React.lazy(() => import("views/app-views/apps/employee/create")),
  },
  {
    key: "apps.employee.edit",
    path: `${APP_PREFIX_PATH}/apps/employee/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/employee/edit")),
  },
  {
    key: "apps.employee.roles.list",
    path: `${APP_PREFIX_PATH}/apps/employee/roles/list`,
    component: React.lazy(() => import("views/app-views/apps/employee/roles")),
  },
  {
    key: "apps.employee.roles.create",
    path: `${APP_PREFIX_PATH}/apps/employee/roles/create`,
    component: React.lazy(() =>
      import("views/app-views/apps/employee/roles/create")
    ),
  },
  {
    key: "apps.employee.roles.edit",
    path: `${APP_PREFIX_PATH}/apps/employee/roles/edit/:id`,
    component: React.lazy(() =>
      import("views/app-views/apps/employee/roles/edit")
    ),
  },
  {
    key: "apps.ticketing.list",
    path: `${APP_PREFIX_PATH}/apps/ticketing/list`,
    component: React.lazy(() => import("views/app-views/apps/ticketing/list")),
  },
  {
    key: "apps.ticketing.create",
    path: `${APP_PREFIX_PATH}/apps/ticketing/create`,
    component: React.lazy(() =>
      import("views/app-views/apps/ticketing/create")
    ),
  },
  {
    key: "apps.ticketing.edit",
    path: `${APP_PREFIX_PATH}/apps/ticketing/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/ticketing/edit")),
  },
  {
    key: "apps.district.outlet",
    path: `${APP_PREFIX_PATH}/apps/outlet/list`,
    component: React.lazy(() => import("views/app-views/apps/outlet/list")),
  },
  {
    key: "apps.district.outlet.create",
    path: `${APP_PREFIX_PATH}/apps/outlet/create`,
    component: React.lazy(() => import("views/app-views/apps/outlet/create")),
  },
  {
    key: "apps.district.outlet.edit",
    path: `${APP_PREFIX_PATH}/apps/outlet/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/outlet/edit")),
  },
  {
    key: "apps.district.list",
    path: `${APP_PREFIX_PATH}/apps/district/list`,
    component: React.lazy(() => import("views/app-views/apps/district/list")),
  },
  {
    key: "apps.district.create",
    path: `${APP_PREFIX_PATH}/apps/district/create`,
    component: React.lazy(() => import("views/app-views/apps/district/create")),
  },
  {
    key: "apps.district.edit",
    path: `${APP_PREFIX_PATH}/apps/district/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/district/edit")),
  },
  {
    key: "apps.inventory.items.list",
    path: `${APP_PREFIX_PATH}/apps/inventory/items/list`,
    component: React.lazy(() => import("views/app-views/apps/product/list")),
  },
  {
    key: "apps.inventory.items.create",
    path: `${APP_PREFIX_PATH}/apps/inventory/items/create`,
    component: React.lazy(() => import("views/app-views/apps/product/create")),
  },
  {
    key: "apps.inventory.items.edit",
    path: `${APP_PREFIX_PATH}/apps/inventory/items/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/product/edit")),
  },
  {
    key: "apps.inventory.modify",
    path: `${APP_PREFIX_PATH}/apps/inventory/modify`,
    component: React.lazy(() =>
      import("views/app-views/apps/inventory/modify")
    ),
  },
  {
    key: "apps.inventory.modify.edit",
    path: `${APP_PREFIX_PATH}/apps/inventory/edit/:id`,
    component: React.lazy(() =>
      import("views/app-views/apps/inventory/modify/edit")
    ),
  },
  {
    key: "apps.inventory.list",
    path: `${APP_PREFIX_PATH}/apps/inventory/list`,
    component: React.lazy(() => import("views/app-views/apps/inventory/list")),
  },
  {
    key: "apps.inventory.category.list",
    path: `${APP_PREFIX_PATH}/apps/inventory/category/list`,
    component: React.lazy(() =>
      import("views/app-views/apps/product/category/list")
    ),
  },
  {
    key: "apps.inventory.category.create",
    path: `${APP_PREFIX_PATH}/apps/inventory/category/create`,
    component: React.lazy(() =>
      import("views/app-views/apps/product/category/create")
    ),
  },
  {
    key: "apps.inventory.category.edit",
    path: `${APP_PREFIX_PATH}/apps/inventory/category/edit/:id`,
    component: React.lazy(() =>
      import("views/app-views/apps/product/category/edit")
    ),
  },
  {
    key: "apps.customer.list",
    path: `${APP_PREFIX_PATH}/apps/customer/list`,
    component: React.lazy(() => import("views/app-views/apps/customer/list")),
  },
  {
    key: "apps.customer.create",
    path: `${APP_PREFIX_PATH}/apps/customer/create`,
    component: React.lazy(() => import("views/app-views/apps/customer/create")),
  },
  {
    key: "apps.customer.edit",
    path: `${APP_PREFIX_PATH}/apps/customer/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/customer/edit")),
  },
  {
    key: "apps.settings.discount",
    path: `${APP_PREFIX_PATH}/apps/settings/discount`,
    component: React.lazy(() => import("views/app-views/apps/promotion/list")),
  },
  {
    key: "apps.settings.discount.create",
    path: `${APP_PREFIX_PATH}/apps/settings/discount/create`,
    component: React.lazy(() =>
      import("views/app-views/apps/promotion/create")
    ),
  },
  {
    key: "apps.settings.discount.edit",
    path: `${APP_PREFIX_PATH}/apps/settings/discount/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/promotion/edit")),
  },
  {
    key: "apps.settings.coupon",
    path: `${APP_PREFIX_PATH}/apps/settings/coupon`,
    component: React.lazy(() => import("views/app-views/apps/coupon/list")),
  },
  {
    key: "apps.settings.coupon.create",
    path: `${APP_PREFIX_PATH}/apps/settings/coupon/create`,
    component: React.lazy(() => import("views/app-views/apps/coupon/create")),
  },
  {
    key: "apps.settings.coupon.edit",
    path: `${APP_PREFIX_PATH}/apps/settings/coupon/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/coupon/edit")),
  },
  {
    key: "apps.settings.tax",
    path: `${APP_PREFIX_PATH}/apps/settings/tax`,
    component: React.lazy(() => import("views/app-views/apps/tax/list")),
  },
  {
    key: "apps.settings.tax.create",
    path: `${APP_PREFIX_PATH}/apps/settings/tax/create`,
    component: React.lazy(() => import("views/app-views/apps/tax/create")),
  },
  {
    key: "apps.settings.tax.edit",
    path: `${APP_PREFIX_PATH}/apps/settings/tax/edit/:id`,
    component: React.lazy(() => import("views/app-views/apps/tax/edit")),
  },
  {
    key: "apps.settings.loyalty",
    path: `${APP_PREFIX_PATH}/apps/settings/loyalty`,
    component: React.lazy(() => import("views/app-views/apps/loyalty")),
  },
  {
    key: "apps.transaction.list",
    path: `${APP_PREFIX_PATH}/apps/transaction/list`,
    component: React.lazy(() =>
      import("views/app-views/apps/transaction/list")
    ),
  },
  {
    key: "apps.transaction.show",
    path: `${APP_PREFIX_PATH}/apps/transaction/show/:inv`,
    component: React.lazy(() =>
      import("views/app-views/apps/transaction/show")
    ),
  },
  {
    key: "apps.report.list",
    path: `${APP_PREFIX_PATH}/apps/report/list`,
    component: React.lazy(() => import("views/app-views/apps/report/list")),
  },
];
